// extracted by mini-css-extract-plugin
module.exports =  {"period":"period__P6HKn","noPaddingTop":"noPaddingTop__GL5yA"};